import React from 'react';
import Radio, { RadioGroup } from '@dealroadshow/uikit-radio';
import { QuestionAlertsType, questionAlertTypes } from './alertsType';
import styles from './questionAlertsTypeSwitcher.module.scss';

interface IProps {
  value: QuestionAlertsType,
  onChange: (value: QuestionAlertsType) => void,
  isDisabled?: boolean,
  isQuestionManager: boolean,
}

const QuestionAlertsTypeSwitcher = ({
  value,
  onChange,
  isDisabled,
  isQuestionManager,
}: IProps) => (
  <RadioGroup
    name="questionAlertsType"
    fieldClassName={ styles.radioGroupWrp }
    className={ styles.radioGroupContainer }
    selectedValue={ value }
    onChange={ onChange }
    dataTest="questionAlertsTypeRadioGroup"
    disabled={ isDisabled }
    isNarrow
  >
    {
      questionAlertTypes(isQuestionManager).map((item) => (
        <Radio
          key={ item.name }
          value={ item.name }
          label={ item.label }
          className={ styles.radioItemWrp }
          dataTest={ item.label }
        />
      ))
    }
  </RadioGroup>
);

export default QuestionAlertsTypeSwitcher;
